import FlashLib from 'flashlib_onlyplay';
import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import EntryPoint from 'Engine/EntryPoint';
import StatesManager from 'Engine/base/states/StatesManager';
import SoundManager from 'Engine/soundManager/SoundManager';
import WinAmountAnimated from '../../winAmountAnimated/selfResizedWin';
import animationCreator from 'Engine/animations/animationCreator';
import SmallWinController from './winControllers/smallWinController';
import BigWinController from './winControllers/bigWinController';
import WinController from './winControllers/winController';
import { gsap } from 'gsap';
import eAnimationTypes from '../../animations/animationTypes';
import { eSounds } from '../../enums/eSounds';
import eBigWinTypes from '../../enums/eBigWinTypes';
import eEventTypes from '../../enums/eEventTypes';
import { eBigWinAnimationNames, eMegaWinAnimationNames } from '../../enums/eAnimationNames';
import { eWinAmountSizes } from '../../enums/eWinAmountSizes';

export default class PopupWin extends FlashLib.MovieClip {
  constructor(data, displayData) {
    super(data, displayData);
    this.eventMode = 'static';
    this.winControllers = {};
    this.stack = [];
    this.cancelExecutionCallbacks = [];
    this.currentStep = null;
    this._completeDelay = 1500;

    this.stepsData = {
      [eBigWinTypes.EBWT_WIN]: {
        controller: SmallWinController,
        config: { animationName: null, sound: eSounds.EST_WIN, duration: 1000, counterOffset: 400 }
      },
      [eBigWinTypes.EBWT_BIG_WIN]: {
        controller: BigWinController,
        delayed: true,
        config: {
          animationName: eBigWinAnimationNames,
          sound: eSounds.EST_BIG_WIN,
          duration: 4000,
          counterOffset: 1500,
        }
      },
      [eBigWinTypes.EBWT_MEGA_WIN]: {
        controller: WinController,
        delayed: true,
        config: {
          animationName: eMegaWinAnimationNames,
          sound: eSounds.EST_MEGA_WIN,
          duration: 4000,
          counterOffset: 1500,
        }
      },
    };

    this._init();
    this._initAnimationPromise = this._initAnimation();
    this._initWinControllers();
    this._addListeners();
  }

  async show() {


    // this.stopMainBackgroundSound();
    // this.startWinBackground();

    this._createStack();
    await this.checkInitializationWinControllers();
    this.visible = true;
    this.winContainer.visible = true;
    this.eventMode = 'static';
    this.alpha = 1;
    this._execute();
  }

  async checkInitializationWinControllers() {
    const promises = [];
    this.stack.forEach(controller => {
      if (controller.promise &&  !controller.promise.isFulfilled) promises.push(controller.promise);
    });
    if (promises.length) {
      window.OPPreloader.showDelayedPreloader();
      await Promise.all(promises);
      window.OPPreloader.hideDelayedPreloader();
    }
  }
  stopMainBackgroundSound() {
    const backgroundMainGameSound = SoundManager.getSound(eSounds.EST_BACKGROUND.soundName);
    gsap.to(backgroundMainGameSound, { volume: 0, duration: 0.5 })
  }

  playMainBackgroundSound() {
    const backgroundMainGameSound = SoundManager.getSound(eSounds.EST_BACKGROUND.soundName);
    gsap.fromTo(backgroundMainGameSound, { volume: 0 }, { volume: eSounds.EST_BACKGROUND.volume, duration: 1.5 })
  }

  // startWinBackground() {
  //   SoundManager.play(eSounds.EST_BIG_WINS_BACKGROUND.soundName, eSounds.EST_BIG_WINS_BACKGROUND.volume, true, eSounds.EST_BIG_WINS_BACKGROUND.group);
  // }
  //
  // stopWinBackground() {
  //   SoundManager.stop(eSounds.EST_BIG_WINS_BACKGROUND.soundName);
  // }

  showOverlay = (duration) => {
    this.bgAnimation.state.setAnimation(0, 'sample_pop-up', true);
    this.bgAnimation.visible = true;
    this.overlay.show(duration / 1000);
    // gsap.killTweensOf(this.panel);
    // gsap.to(this.panel, {alpha: 0, duration});
  };

  _init() {
    this.visible = false;
    this.overlay = this.getChildByName('overlay');
    this.overlay.alpha = 0.95;
    this.overlay.changeColor('0x000000');

    // this.bgAnimation = this.getChildByName('bgAnimation');

    this.wrapper = this.getChildByName('wrapper');
    // this.panel = this.wrapper.getChildByName('panel');
    this.winContainer = this.wrapper.getChildByName('smallPanel');
    this.winContainer.visible = false;
    this.winAmount = this.winContainer.getChildByName('amount');

    this.counter = new WinAmountAnimated(this.winAmount, { fontSize: eWinAmountSizes.H.REGULAR });
    this.counter.decimals = EntryPoint.GameModel.currencyInfo.decimals;

    this._hideOverlay();
  }

  async _initAnimation() {
    const container = this.wrapper.getChildByName('animationContainer');
    // this.bgAnimation = animationCreator.createAnimation(eAnimationTypes.BIG_WIN);
    this.bgAnimation = await animationCreator.createAnimationWithDelayedLoading(eAnimationTypes.BIG_WIN);
    this.bgAnimation.visible = false;
    container.addChild(this.bgAnimation);

    this.animation = await animationCreator.createAnimationWithDelayedLoading(eAnimationTypes.BIG_WIN);
    this.animation.visible = false;
    // this.animation.state.addListener(this.animationListener);
    container.addChild(this.animation);
  }

  _initWinControllers() {
    [this.stepsData].forEach(steps => {
      for (let key in steps) {
        if (this.winControllers.hasOwnProperty(key)) continue;
        this.winControllers[key] = new steps[key].controller({
          controllerPopup: this,
          config: steps[key].config,
          animation: this.animation,
          counter: this.counter,
        });

        if (steps[key].delayed) {
          this.winControllers[key].promise = new Promise(async (resolve) => {
            await this._initAnimationPromise;
            this.winControllers[key].animation = this.animation;
            this.winControllers[key].promise.isFulfilled = true;
            resolve();
          });
        }
      }
    });
  }

  _addListeners() {
    GlobalDispatcher.add(eEventTypes.EET_SHOW_WIN_STATE__START, this.show, this);
    GlobalDispatcher.add(eEventTypes.EET_STOP_WIN_STATE__START, this._stop, this);
    GlobalDispatcher.add(eEventTypes.EET_STOP_WIN_STATE__END, this._hide, this);
    this.on('pointertap', () => {
      StatesManager.goToNextState();
    });
    window.OPWrapperService.eventManager.add(
      window.OPWrapperService.eventManager.types.EET_SCALE_MANAGER_RESIZE,
      this._onGameResized,
      this
    );
  }

  _onGameResized(data) {
    if (data.isLandscape) {
      this.wrapper.anchorDefault();
      this.wrapper.scale.set(this.wrapper.displayData.scaleX);

      this.winAmount.anchorDefault();
      this.winAmount.scale.set(this.winAmount.displayData.scaleX);
    } else if (data.isMobile && data.isPortrait) {
      this.wrapper.y = this.displayData.height / 2 - 660;
      this.wrapper.x = this.displayData.width / 2 - 45;
      this.wrapper.scale.set(0.6);

      this.winAmount.scale.set(1.6);
    }

  }

  _createStack() {
    for (let key in this.winControllers) {
      if (EntryPoint.GameModel.totalWin / EntryPoint.GameModel.bet > EntryPoint.GameModel.winRankCoef[key]) {
        const controller = this.winControllers[key];
        const cancelExecutionCallback = controller.once('complete', this._execute);
        this.cancelExecutionCallbacks.push(cancelExecutionCallback);

        controller.startValue = EntryPoint.GameModel.winRankCoef[key] * EntryPoint.GameModel.bet;
        controller.endValue = EntryPoint.GameModel.totalWin;

        if (this.stack.length) this.stack[this.stack.length - 1].endValue = controller.startValue;

        this.stack.push(controller);
      }
    }
  }

  _execute = () => {
    if (!this.stack.length) {
      this._complete();
      return;
    }

    this.currentStep = this.stack.shift();
    this.currentStep.start();
  };

  _complete() {
    GlobalDispatcher.dispatch(eEventTypes.EET_BIG_WIN__SKIP);
  }

  _stop() {
    this.counter.stop();
    this.counter.set(EntryPoint.GameModel.totalWin);

    this._cancelScheduledExecutions();
    this.currentStep.stop();

    if (this.stack.length) {
      this.stack.forEach(controller => controller.onSkip());

      this.currentStep = this.stack[this.stack.length - 1];
      this.currentStep.setIdle();
      this.stack = [];
    }

    this._waitCompleteDelay();
  }

  _cancelScheduledExecutions() {
    this.cancelExecutionCallbacks.forEach(cancelExecution => cancelExecution());
    this.cancelExecutionCallbacks = [];
  }

  _waitCompleteDelay = (timestamp = 0) => {
    if (!this._startWaitPoint) this._startWaitPoint = timestamp;
    if (timestamp - this._startWaitPoint >= this._completeDelay) {
      this._startWaitPoint = null;
      this._tryToHide();
      GlobalDispatcher.dispatch(eEventTypes.EET_BIG_WIN__SKIP_COMPLETED);
      return;
    }

    requestAnimationFrame(this._waitCompleteDelay);
  };

  _tryToHide() {
    if (this._isHiding || this.visible === false) return;
    this._hide();
  }

  _hide() {
    this.eventMode = 'none';
    this._isHiding = true;
    // this.stopWinBackground();
    // this.playMainBackgroundSound();
    gsap.to(this, {
      alpha: 0, duration: 0.4, onComplete: () => {
        this.visible = false;
        this.animation.visible = false;
        this.winContainer.visible = false;
        this._hideOverlay();
        Object.values(this.winControllers).forEach(controller => controller.cleanup());
      }
    })
  }

  _hideOverlay() {
    if (this.bgAnimation) {
      this.bgAnimation.visible = false;
      this.bgAnimation.lastTime = null;
      this.bgAnimation.state.clearTrack(0);
      this.bgAnimation.skeleton.setToSetupPose();
    }
    this.overlay.hide();
    // gsap.killTweensOf(this.panel);
    // this.panel.alpha = 1;
  }
}

